export default __webpack_public_path__ + "static/media/illus-trainModels.ca857fa9.svg";